import type { Theme } from "@emotion/react";
import { css } from "@emotion/react";

export const navigationButtons = css`
  display: flex;
  justify-content: center;
`;

export const iconButton = css`
  &[disabled] {
    pointer-events: auto;
  }
`;

export const iconChev = (theme: Theme) => css`
  path {
    fill: ${theme.text.body};
  }
`;
